const FRANCHISE_REF_ID_API_URL =
  'https://ib-forms-backend-alpha.apigateway.in/api/ib_forms/franchise_ref_id/v1/'
const BACKEND_URL = `https://ibgroup-backend-prod.apigateway.in/api/ib_mauticstorage/forms/`
const FORM_API_URL =
  'https://ib-forms-backend-prod-apis.ibhubs.in/api/ib_forms/form_submission/v1/'
const SOURCE = `IBC`
const MAUTIC_URL = `https://events.proyuga.tech/`

export const submitFormAPI = (
  data,
  onSuccess = () => {},
  onFailure = () => {}
) => {
  const storeInBackend = (userDetails, franchiseRefId) => {
    const submitted = false
    const formData = {
      ...data.submission_data,
      User_Tracking_Details: userDetails,
      Reference_ID: franchiseRefId
    }
    const requestObject = {
      ...data,
      submission_data: JSON.stringify(formData)
    }
    const formattedrequestObject = JSON.stringify(JSON.stringify(requestObject))
    const dataRequestObject = JSON.stringify({
      data: formattedrequestObject,
      clientKeyDetailsId: 1
    })
    $.ajax({
      type: 'POST',
      url: FORM_API_URL,
      data: dataRequestObject,
      contentType: 'application/json; charset=UTF-8'
    })
      .done(() => {
        if (!submitted) {
          onSuccess()
        }
      })
      .fail(() => {
        onFailure()
      })
  }
  const getUserTrackingDetailsPromise = () =>
    $.ajax({
      crossDomain: true,
      method: 'GET',
      url: 'http://ip-api.com/json'
    })

  const getFranchiseRefIdPromise = () =>
    $.ajax({
      type: 'GET',
      url: FRANCHISE_REF_ID_API_URL,
      contentType: 'application/json; charset=UTF-8'
    })

  const franchiseRefIdPromise = getFranchiseRefIdPromise()
  const userTrackingDetailsPromise = getUserTrackingDetailsPromise()
  return Promise.all([franchiseRefIdPromise, userTrackingDetailsPromise])
    .then(data => {
      storeInBackend(data[1], data[0].ref_id.toUpperCase())
    })
    .catch(() => {
      franchiseRefIdPromise
        .then(response => {
          userTrackingDetailsPromise.catch(() => {
            storeInBackend({}, response.ref_id.toUpperCase())
          })
        })
        .catch(() => {
          userTrackingDetailsPromise
            .then(userDetails => {
              storeInBackend(userDetails, '-1')
            })
            .catch(() => {
              storeInBackend({}, '-1')
            })
        })
    })
}

export const submitBackendForm = (
  data,
  formId,
  onSuccess = () => {},
  onFailure = () => {}
) => {
  const storeInBackend = userDetails => {
    const submitted = false
    const requestObject = {
      description: $.param(data),
      source: `${SOURCE}`,
      meta_data: $.param(userDetails)
    }
    const formattedrequestObject = JSON.stringify(JSON.stringify(requestObject))
    const dataRequestObject = JSON.stringify({
      data: formattedrequestObject,
      clientKeyDetailsId: 1
    })
    $.ajax({
      type: 'POST',
      url: `${BACKEND_URL}${formId}/`,
      data: dataRequestObject,
      contentType: 'application/json; charset=UTF-8'
    })
      .done(() => {
        if (!submitted) {
          onSuccess()
        }
      })
      .fail(() => {
        onFailure()
      })
  }
  /* retriving user details for tracking */
  $.ajax({
    crossDomain: true,
    method: 'GET',
    url: 'http://ip-api.com/json'
  })
    .done(userDetails => {
      storeInBackend(userDetails)
    })
    .fail(() => {
      storeInBackend({})
    })
}

export const submitForm = (
  formValues,
  formId,
  formName,
  resolve = () => {},
  reset = () => {}
) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    let submitted = false
    const formUrl = `https://events.proyuga.tech/form/submit?formId=${formId}`
    const returnUrl = `https://events.proyuga.tech/form/${formId}`
    // console.log(updatedValues, initialData, values)
    const serializedData = {
      'mauticform[return]': returnUrl,
      'mauticform[messenger]': '1',
      'mauticform[formId]': formId,
      'mauticform[formName]': formName
    }
    Object.keys(formValues).map((fieldId, index) => {
      serializedData[`mauticform[${fieldId}]`] = formValues[fieldId]
    })
    // console.log('serializedData', serializedData)
    const mauticSerializedData = $.param(serializedData)
    // alert(serializedData);
    $.ajax({
      type: 'POST',
      url: formUrl,
      data: mauticSerializedData,
      contentType: 'application/x-www-form-urlencoded'
    })
      .done(response => {
        // alert('success', response);
        resolve()
        reset()
        submitted = true
      })
      .fail(response => {
        // alert('api failed', response);
        // reject(response);
        resolve()
        reset()
        submitted = true
      })
    const requestObject = {
      description: mauticSerializedData,
      source: 'PROYUGA'
    }
    const formattedrequestObject = JSON.stringify(JSON.stringify(requestObject))
    const dataRequestObject = JSON.stringify({
      data: formattedrequestObject,
      clientKeyDetailsId: 1
    })
    $.ajax({
      type: 'POST',
      url: `https://ibgroup-backend-alpha.apigateway.in/api/ib_mauticstorage/forms/${formId}/`,
      data: dataRequestObject,
      contentType: 'application/json; charset=UTF-8'
    })
      .done(response => {
        // alert('success', response);
        if (!submitted) {
          resolve()
          reset()
        }
      })
      .fail(response => {
        // alert('api failed', response);
        // reject(response);
        if (!submitted) {
          resolve()
          reset()
        }
      })
  }
}
